// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eb1cd91b{position:relative}", "",{"version":3,"sources":["webpack://./src/common/components/Dropdown/Base/Header/DropdownBaseHeader.scss"],"names":[],"mappings":"AAAA,UACE,iBAAA","sourcesContent":[".dropdownbaseheader {\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownbaseheader": "eb1cd91b"
};
export default ___CSS_LOADER_EXPORT___;
